import React from 'react';
import { WaveSine } from 'phosphor-react';
import { OptionsPageShell } from '../../components/options/OptionsPageShell';
import { OptionsGexCard } from '../../components/options/OptionsGexCard';
import { OptionsProLockedFeature } from '../../components/options/OptionsProLockedFeature';
import { useOptionsEntitlements } from '../../context/OptionsEntitlementsContext';
import GeniLoader from '../../components/GeniLoader';

export default function OptionsGex() {
  const { entitlements, loading } = useOptionsEntitlements();
  return (
    <OptionsPageShell hideHeader>
      <main className="min-h-[calc(100vh-180px)] w-full py-6 sm:py-8" data-testid="options-gex-page">
        <div className="mx-auto w-full max-w-[1100px] space-y-7">
          <header className="border-b border-white/5 pb-5" data-testid="options-gex-page-header">
            <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-white/40" data-testid="options-gex-page-eyebrow">
              <WaveSine size={14} weight="bold" />
              <span>GENI OPTIONS</span>
            </div>
            <h1 className="mt-2 text-3xl font-black tracking-tight text-white" data-testid="options-gex-page-title">GEX — Gamma Exposure</h1>
            <p className="mt-2 text-sm text-white/60" data-testid="options-gex-page-description">
              Indicadores agregados da cadeia de opções BTC da Deribit.
            </p>
          </header>

          {loading ? (
            <div className="flex min-h-56 items-center justify-center" data-testid="options-gex-entitlements-loading"><GeniLoader size="md" /></div>
          ) : entitlements.GEX ? (
            <OptionsGexCard />
          ) : (
            <OptionsProLockedFeature
              featureKey="GEX"
              title="GEX — Gamma Exposure"
              description="Acesse Gamma Regime, Gamma Flip, Positive Peak (P1) e Negative Peak (N1) com dados agregados da cadeia BTC. Estimativa proxy; não representa posicionamento real de dealers."
              testId="options-gex-pro-lock"
            />
          )}
        </div>
      </main>
    </OptionsPageShell>
  );
}